module.exports = __webpack_public_path__ + "img/Mapping.ef16e14a.svg";